import { functionFrom, FunctionLibrary, getFunctionSignature } from '../FunctionDefinition';
import { TYPES } from '../Types';

const ifNumber = functionFrom(
  'if',
  [
    { name: 'condition', type: TYPES.boolean },
    { name: 'thenValue', type: TYPES.number, isLazy: true },
    { name: 'elseValue', type: TYPES.number, isLazy: true },
  ] as const,
  TYPES.number,
  (_ctx, condition, getThenValue, getElseValue) => (condition ? getThenValue() : getElseValue()),
  'Conditional expression: returns `thenValue` if `condition` is true, otherwise `elseValue`. Operands are evaluated lazily to enable short-circuit.',
);

const ifString = functionFrom(
  'if',
  [
    { name: 'condition', type: TYPES.boolean },
    { name: 'thenValue', type: TYPES.string, isLazy: true },
    { name: 'elseValue', type: TYPES.string, isLazy: true },
  ] as const,
  TYPES.string,
  (_ctx, condition, getThenValue, getElseValue) => (condition ? getThenValue() : getElseValue()),
  'Conditional expression: returns `thenValue` if `condition` is true, otherwise `elseValue`. Operands are evaluated lazily to enable short-circuit.',
);

const ifDuration = functionFrom(
  'if',
  [
    { name: 'condition', type: TYPES.boolean },
    { name: 'thenValue', type: TYPES.duration, isLazy: true },
    { name: 'elseValue', type: TYPES.duration, isLazy: true },
  ] as const,
  TYPES.duration,
  (_ctx, condition, getThenValue, getElseValue) => (condition ? getThenValue() : getElseValue()),
  'Conditional expression: returns `thenValue` if `condition` is true, otherwise `elseValue`. Operands are evaluated lazily to enable short-circuit.',
);

const ifPlainDate = functionFrom(
  'if',
  [
    { name: 'condition', type: TYPES.boolean },
    { name: 'thenValue', type: TYPES.plainDate, isLazy: true },
    { name: 'elseValue', type: TYPES.plainDate, isLazy: true },
  ] as const,
  TYPES.plainDate,
  (_ctx, condition, getThenValue, getElseValue) => (condition ? getThenValue() : getElseValue()),
  'Conditional expression: returns `thenValue` if `condition` is true, otherwise `elseValue`. Operands are evaluated lazily to enable short-circuit.',
);

const ifPlainTime = functionFrom(
  'if',
  [
    { name: 'condition', type: TYPES.boolean },
    { name: 'thenValue', type: TYPES.plainTime, isLazy: true },
    { name: 'elseValue', type: TYPES.plainTime, isLazy: true },
  ] as const,
  TYPES.plainTime,
  (_ctx, condition, getThenValue, getElseValue) => (condition ? getThenValue() : getElseValue()),
  'Conditional expression: returns `thenValue` if `condition` is true, otherwise `elseValue`. Operands are evaluated lazily to enable short-circuit.',
);

const ifZonedDateTime = functionFrom(
  'if',
  [
    { name: 'condition', type: TYPES.boolean },
    { name: 'thenValue', type: TYPES.zonedDateTime, isLazy: true },
    { name: 'elseValue', type: TYPES.zonedDateTime, isLazy: true },
  ] as const,
  TYPES.zonedDateTime,
  (_ctx, condition, getThenValue, getElseValue) => (condition ? getThenValue() : getElseValue()),
  'Conditional expression: returns `thenValue` if `condition` is true, otherwise `elseValue`. Operands are evaluated lazily to enable short-circuit.',
);

export const LOGICAL_FUNCTIONS = {
  [getFunctionSignature(ifNumber)]: ifNumber,
  [getFunctionSignature(ifString)]: ifString,
  [getFunctionSignature(ifPlainDate)]: ifPlainDate,
  [getFunctionSignature(ifPlainTime)]: ifPlainTime,
  [getFunctionSignature(ifZonedDateTime)]: ifZonedDateTime,
  [getFunctionSignature(ifDuration)]: ifDuration,
} satisfies FunctionLibrary;
